// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "物流经济地理",
        "tec": "王爽",
        "week": "1-8周",
        "add": "教学楼D座313文法"
      },
      {
        "sub": "劳动与创造",
        "tec": "贲立欣",
        "week": "13周",
        "add": "教学楼D座325经管"
      }
    ],
    [
      {
        "sub": "国际物流学",
        "tec": "田凤权",
        "week": "1-12周",
        "add": "教学楼D座313文法"
      },
      {
        "sub": "劳动与创造",
        "tec": "贲立欣",
        "week": "13周",
        "add": "教学楼D座325经管"
      }
    ],
    {
      "sub": "宏观经济学",
      "tec": "姜博",
      "week": "1-12周",
      "add": "教学楼D座313文法"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "孙新",
        "week": "1-8周",
        "add": "教学楼A座122信息"
      },
      {
        "sub": "国家安全教育",
        "tec": "孙新",
        "week": "9-12周",
        "add": "教学楼A座122信息"
      }
    ],
    0
  ],
  "2": [
    [
      {
        "sub": "第三方物流案例分析",
        "tec": "孙宏英",
        "week": "1-12周",
        "add": "教学楼D座313文法"
      },
      {
        "sub": "劳动与创造",
        "tec": "贲立欣",
        "week": "13周",
        "add": "教学楼D座325经管"
      }
    ],
    [
      {
        "sub": "运输与配送管理",
        "tec": "李化",
        "week": "1-12周",
        "add": "教学楼D座313文法"
      },
      {
        "sub": "劳动与创造",
        "tec": "贲立欣",
        "week": "13周",
        "add": "教学楼D座325经管"
      }
    ],
    {
      "sub": "就业创业指导",
      "tec": "王倩",
      "week": "2-6周",
      "add": "教学楼D座426经管"
    },
    0,
    {
      "sub": "能源电力工程与绿色低碳技术",
      "tec": "高建华张翼",
      "week": "1-8周",
      "add": "教学楼C座212教务"
    }
  ],
  "3": [
    {
      "sub": "物流经济地理",
      "tec": "王爽",
      "week": "1-8周",
      "add": "教学楼D座313文法"
    },
    {
      "sub": "物流统计学",
      "tec": "贲立欣",
      "week": "1-12周",
      "add": "教学楼D座313文法"
    },
    0,
    0,
    0
  ],
  "4": [
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "孙新",
        "week": "1-8周",
        "add": "教学楼A座222电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "孙新",
        "week": "9-12周",
        "add": "教学楼A座222电力"
      }
    ],
    {
      "sub": "运输与配送管理",
      "tec": "李化",
      "week": "1-12周",
      "add": "教学楼D座313文法"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "宏观经济学",
      "tec": "姜博",
      "week": "1-4周",
      "add": "教学楼D座313文法"
    },
    {
      "sub": "物流统计学",
      "tec": "贲立欣",
      "week": "1-12周",
      "add": "教学楼D座313文法"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
